import ErrorIcon from 'components/ReusableComponents/BackgroundImage/ErrorIcon'
import LiteLoadingIndicator from 'components/ReusableComponents/LiteLoadingIndicator'
import { useEffect, useState } from 'react'

import styles from './BackgroundImage.module.scss'

const BackgroundImage = ({ src, title = '', ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    if (src) {
      const imageLoader = new Image()
      imageLoader.src = src

      imageLoader.onload = () => {
        setIsLoaded(true)
        setIsErred(false)
      }

      imageLoader.onerror = () => {
        setIsErred(true)
        setIsLoaded(false)
      }
    }
  }, [src])

  if (!src || isErred) {
    return (
      <div title={title} className={styles.errorContainer}>
        <ErrorIcon className={styles.errorIcon} />
      </div>
    )
  }

  return (
    <div
      style={{
        background: isLoaded ? `url("${src}")` : '#f3f3f3'
      }}
      {...props}
      title={title}
    >
      {!isLoaded && (
        <div className={styles.loadingHolder}>
          <LiteLoadingIndicator />
        </div>
      )}
    </div>
  )
}
export default BackgroundImage
